import { ComunicazioneDTO } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Drawer } from '@framework/ui';
import { AnyObject, ObjectSchema } from '@framework/validation';
import { message } from 'antd';
import * as React from 'react';
import { useEffect } from 'react';
import { CommunicationForm } from './form/CommunicationForm';
import { ICommonCommunicationProps } from './logic/ICommonCommunicationProps';

export interface ICommunicationButtonDrawerProps<
  T extends AnyObject,
  TSchema extends ObjectSchema<T> = ObjectSchema<T>,
> extends Omit<ICommonCommunicationProps<T, TSchema>, 'deleteDraft'> {
  /** Comunicazione selezionata */
  communication?: ComunicazioneDTO | null;
  /** Titolo del Drawer */
  title?: React.ReactNode;
  validationSchema: TSchema;
  onClose?: () => void;
  taskId?: string;
}

/**
 * Drawer creazione e invio di una nuova comunicazione
 */
export function CommunicationButtonDrawer<
  T extends AnyObject,
  TSchema extends ObjectSchema<T>,
>(props: ICommunicationButtonDrawerProps<T, TSchema>) {
  const { communication, title, validationSchema, onSubmit, onClose, taskId } =
    props;
  const { t } = useTranslation();

  const open = communication != null;

  const handleClose = () => {
    onClose?.();
  };

  useEffect(() => {
    message.config({ top: open ? 0 : 70 });
  }, [open]);

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      destroyOnClose
      maskClosable={false}
      title={
        title ?? communication?.id
          ? t('communication-button.send-comm', 'Invio Comunicazione')
          : t('communication-button.new-comm', 'Nuova Comunicazione')
      }
      size="large"
      placement="right"
    >
      <CommunicationForm
        communication={communication}
        validationSchema={validationSchema as any}
        onClose={handleClose}
        onSubmit={onSubmit}
        taskId={taskId}
        sendCommunication={props.sendCommunication}
        uploadAttachment={props.uploadAttachment}
        attachExisting={props.attachExisting}
        removeAttachment={props.removeAttachment}
        getDownloadAttachmentQueryOptions={
          props.getDownloadAttachmentQueryOptions
        }
      />
    </Drawer>
  );
}
